<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" id="illustrations">
<div class="header">
<h3>List of Illustrations</h3>
</div>
<ol>
<li><a href="#/Text/Section0005#plate09">Next he kissed her lips and she kissed his and . . . when the two little slave-girls saw their young master go in unto the damsel, Anis al-Jalis, they cried out</a></li>
<li><span href="#/Text/Section0008#plate10" title="Link target outside of Sample">One night as he laid by her side . . . she awoke and sat upright. . . . When Ghanim heard her words and knew that she was a concubine of the Caliph, he drew back</span></li>
<li><span href="#/Text/Section0009#plate11" title="Link target outside of Sample">He set his breast against hers; but when he felt waist touch waist his strength failed him, and she . . . threw him to the ground</span></li>
<li><span href="#/Text/Section0009#plate12" title="Link target outside of Sample">When the vile slave heard this from her, he waxt more enraged and his eyes grew redder: and he came up to her and, smiting her with the sword on her neck, wounded her to the death</span></li>
<li><span href="#/Text/Section0009#plate13" title="Link target outside of Sample">So at last we lifted up the door; and, going in, found him dead, with his flesh torn into strips and bits and his bones broken. When we saw him in this condition it was grievous to us</span></li>
<li><span href="#/Text/Section0011#plate14" title="Link target outside of Sample">I stood behind the door . . . and ere I knew it a damsel ran up . . . she had tucked up her trousers to her knees</span></li>
<li><span href="#/Text/Section0011#plate15" title="Link target outside of Sample">The King . . . being violently enraged, seized a dagger, and was about to strike Taj al-Muluk with it</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?16e50b1a